// cSpell:ignore flexbox, STYuanti

import React from 'react';
import styled from 'styled-components';

import { Flex, BrownRow, TwoTitle } from './static/style';

function PathTitle(props) {
    return (
        <TitleBackground type={(props && props.type) ? props.type : null}>
            {props.level && (
                <TopTitle onClick={props.onClick}>
                    <div>{props.level}</div>
                    <Row />
                </TopTitle>
            )}
            {props.title && <BottomTitle>{props.title}</BottomTitle>}
        </TitleBackground>
    );
}

export default PathTitle;

const TitleBackground = styled(Flex)`
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    width: 9.62rem;
    /* width: 9.62rem;
    height: 2.13rem;
    background: url(${require('./static/img/title-bg.png')}) no-repeat top center;
    background-size: contain; */
    ${props => (props && props.type && props.type === 'simple') ? `
            height: 1.82rem;
            background: url(${require('./static/img/title-bg-simple.png')}) no-repeat top center;
            background-size: contain;
        ` : `
            height: 2.13rem;
            background: url(${require('./static/img/title-bg.png')}) no-repeat top center;
            background-size: contain;
            padding-left: 0.7rem;
        `
    }
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;

    > div {
        width: 5rem;
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        white-space: nowrap;
    }
`;

const TopTitle = styled.div`
    position: relative;
    height: 0.53rem;
    color: #84451a;
    font-size: 0.38rem;
    cursor: pointer;
`;

const BottomTitle = styled(TwoTitle)`
    height: 0.45rem;
`;

const Row = styled(BrownRow)`
    position: absolute;
    top: 0.18rem;
    right: 0.9rem;
`;



// WEBPACK FOOTER //
// ./src/lib/components/LessonPath/path-title.js